import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import VerdictDisplayFeedback from './Partials/Feedback';
import VerdictDisplayLevel from './Partials/Level';
import { getVerdictScales } from 'actions/studyplans';
import { getActiveLanguage } from '@haldor/ui';
var VerdictDisplay = /*#__PURE__*/function (_Component) {
  function VerdictDisplay() {
    var _this;
    _classCallCheck(this, VerdictDisplay);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, VerdictDisplay, [].concat(args));
    _defineProperty(_this, "componentDidMount", function () {
      if (_this.props.scales == null) {
        _this.props.getVerdictScales(_this.props.currentStudent.id, getActiveLanguage());
      }
    });
    _defineProperty(_this, "getScale", function (scaleId) {
      if (_this.props.scales == null || _this.props.scales.length == 0) {
        return null;
      }
      var found = _this.props.scales.find(function (scale) {
        return scale.id == scaleId;
      });
      if (found != null) {
        return found;
      }
      return _this.props.scales[0];
    });
    return _this;
  }
  _inherits(VerdictDisplay, _Component);
  return _createClass(VerdictDisplay, [{
    key: "render",
    value: function render() {
      if (this.props.verdict == null) {
        return null;
      }
      var scale = this.getScale(this.props.verdict.scaleId);
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-display-container"
      }, scale != null ? /*#__PURE__*/React.createElement(VerdictDisplayLevel, {
        verdict: this.props.verdict,
        scale: scale
      }) : null, /*#__PURE__*/React.createElement(VerdictDisplayFeedback, {
        verdict: this.props.verdict
      }));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    scales: state.studyplans.scales,
    activeStudent: state.guardians.activeStudent,
    currentStudent: state.guardians.currentStudent
  };
}
export default connect(mapStateToProps, {
  getVerdictScales: getVerdictScales
})(VerdictDisplay);